import { Box, Icon } from '@hover/blueprint';
import { iShare } from '@hover/icons';
import React, { useState } from 'react';

import { Button } from 'src/shared/components';
import { FeatureTracking } from 'src/shared/constants/FeatureFlag';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface ShareModalProps {
  handleCloseButton: () => void;
  handleConsentChecked: () => void;
  isConsentChecked: boolean;
  isModalOpen: boolean;
}

interface ShareButtonProps {
  ShareModal: (props: ShareModalProps) => JSX.Element;
  iconOnly?: boolean;
  color?: string;
}

const ShareButton = ({
  color = 'neutral900',
  ShareModal,
  iconOnly,
}: ShareButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const handleToggleOpenModal = () => {
    if (isModalOpen) {
      setIsConsentChecked(false);
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleConsentChecked = () => setIsConsentChecked(!isConsentChecked);

  const t = useTranslate(TranslationNamespace.SHARED);
  const trackingProperties = {
    track_id: 'rendering-share',
    feature: FeatureTracking.RENDERING,
  };

  return (
    <Box alignItems="center" testId="share-button">
      <Button
        fill="minimal"
        fontSize="200"
        fontWeight="400"
        iconAfter={iconOnly ? undefined : iShare}
        onClick={handleToggleOpenModal}
        optionalTrackingProperties={trackingProperties}
        shape={iconOnly ? 'square' : 'box'}
        sx={{ color }}
      >
        {!iconOnly && t('renderings.share')}
        {iconOnly && <Icon icon={iShare} />}
      </Button>
      <ShareModal
        handleCloseButton={handleToggleOpenModal}
        handleConsentChecked={handleConsentChecked}
        isConsentChecked={isConsentChecked}
        isModalOpen={isModalOpen}
      />
    </Box>
  );
};

export { ShareButton };
